/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TextWidgetConfiguration extends models.WidgetConfiguration {
    constructor() {
        super();
        this.setDiscriminator("TextWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return TextWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<TextWidgetConfiguration>): TextWidgetConfiguration {
        let obj = Object.assign(new TextWidgetConfiguration(), model);
        TextWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TextWidgetConfiguration>): TextWidgetConfiguration {
        if (!model) return null;
        return TextWidgetConfiguration.newInstance(<TextWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TextWidgetConfiguration) {
        if (!obj) return;

        models.TextWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TextWidgetConfiguration): boolean {
        if (models.WidgetConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TextWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    text: string;

    color: string;

    alignment: models.HorizontalAlignment;

    preventWrapping: boolean;

}
